<template>
  <DefaultLayout>
    <component
        :is="currentComponent"
        :user-info="userInfo"
        :matching-result="matchingResult"
        @update-user-info="updateUserInfo"
        @submit-user-info="submitUserInfo"
        @matches-submitted="showMatchingResult"
        @return-home="returnHome"
    />
  </DefaultLayout>
</template>

<script>
import Step1 from './components/matching-form-page.vue';
import Step2 from './components/matching-game-page.vue';
import Step3 from './components/matching-results-page.vue';

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      currentStep: 1, // Tracks the current step
      userInfo: {
        fname: '',
        lname: '',
        email: '',
        phone: '',
        acceptGdpr: false,
        newsletter: false,
      },
      matchingResult: null
    };
  },
  computed: {
    currentComponent() {
      // Map the current step to its corresponding component
      return `Step${this.currentStep}`;
    },
  },
  methods: {
    updateUserInfo(newUserInfo) {
      this.userInfo = newUserInfo;
    },
    submitUserInfo() {
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },
    showMatchingResult(result) {
      this.matchingResult = result;
      this.currentStep = 3;
      window.scrollTo(0, 0);
    },
    returnHome() {
      this.currentStep = 1;
      this.userInfo = {
        fname: '',
        lname: '',
        email: '',
        phone: '',
        newsletter: false,
        acceptGdpr: false,
      };
      this.matchingResult = null;
      window.scrollTo(0, 0);
    }
  },
};
</script>
